// extracted by mini-css-extract-plugin
export var glowingButtonAnimation = "title-module--glowing-button-animation--e5830";
export var gradientLine = "title-module--gradientLine--8a6e9";
export var title = "title-module--title--7e57f";
export var wrapper = "title-module--wrapper--d30d7";